import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'RMApprove',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate : '',
        toDate:'',
        searchflag:false,
        localuserid:'',
        localusermailid:'',
        pageno: 1,
        pagecount: 0,
        hubname:'',
        debitFrom:'',
        ShippingId:'',
        ShipmentData:'',
        raiseRMDebitNoteEditflag:false,
        getShipmentsflag:false,
        getDebitAmountflag:false,
        getShipmentslogData:[],
        getShipmentsSummeryData:[],
        getDebitAmountData:[],
        raiseRMDebitNoteData:[],
        selectedItems: [],
        getDebitAmountDataLog:[],
        selectAllItems: false,
        selectedItemsonPopup:[],
        selectAllItemsonPopup: false,
        raiseRMDebitNotecomment:'',
        DebitShareinRs:'',
        Percentage:'',
        hubID:[],
        hubzoneid:'',
        hubList:[],
        hubZoneList:[],
        amount:0,
        RMApproveAllRecord:'',
        selectEditItemsList : [],
        isAPICallFlag : true,
        adjustDebitAmount : 0,
        isDebitPersonSelected : "",
        getShippingIdforLog : "",
        debitPersonAmount :[],
        debitPersonPercent :[],
        getShipmentLostMasterID : '',
        getShipmentLostDetailsID : [],
        ShipmentLostMasterID : '',
        Loading: false,
        LoaderForPopup:false,
        localhubdetails: '',
        hubinfo: '',
        getAttachmentListData: [],
        getAttachmentFlag: false,
        attachmentLoader: false,
        RmApproveLoaderBtn: false,
        totalRecords:0,
        totalSelectedRecords:0,
        ExportRmApproveLoaderBtn: false,
        approvalDebitResultStatus: [],
        isPendingGroupIdLoader: false,
        modelValue: false,
        styleObjectFailure : {
          'background-color' : 'red'
        },
        styleObjectSuccess: {
          'background-color' : 'green'
        },
        selectAllItems: false,
        newid : [],
        Vertical : '',
        awbnumbers: '',
        ShipmentType: '',
        CenterTypeList: [],
        CenterType : '',
        hubStateList : [],
        hubCitybyStateList : [],
        hubNameList : [],
        hubStateId : '',
        hubCityId : '',
        AORList : [],
        AOR : '',
        selectedHubZoneId : '',
        selectedStateId : '',
        selectedCityId : '',
        selectedAOR : '',
        selectedCenterType : '',
        filteredHubList : [],
        usernames : '',
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        debitFromModal : false,
        debitPersonDetails : null
      }
  },
  created: function() {
  },
async mounted(){
    let validateUser = await this.validateJwtToken();
    this.getHubList("hubList");
    this.getHubZoneList();
    this.getCenterTypeList();
    this.getServiceCentreList("");
    this.getHubStateList();
    this.getAORList();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    //console.log('Mixin is working for :',result);
  },
  methods : {
    calculateselectedcount(){
     this.totalSelectedRecords = this.selectedItems.length
    },
    searchData() {
      if (this.usernames && !this.reg.test(this.usernames)) {
        this.$alertify.error('Please enter a valid email address');
        return false
      }
      this.RMApproveAllRecord = false
      this.searchflag = true
      this.pageno = 1
      this.selectedItems = []
      this.totalSelectedRecords = 0
      this.selectAllItems = false
      this.$refs.paginate.selected= 0;
      this.SearchShipmets()
    },
    SearchShipmets(){
      if(this.toDate >= this.fromDate ){
        //this.searchflag=true;
        this.Loading = true;
        this.searchflag = true;

        let hubIDarray = []
        if(this.hubID.length > 0 ){
          this.hubID.map(hub=>{
            hubIDarray.push(hub.HubID)
          })
        }
        if (this.ShipmentType =="All"){
          this.ShipmentType = ""
        }
        let data={
            fromDate:this.fromDate ,
            toDate: this.toDate,
            HubZoneID: this.hubzoneid,
            DebitFromType: this.debitFrom,
            HubId: hubIDarray,
            Vertical: this.Vertical,
            CenterType: this.CenterType,
            offset : this.pageno - 1,
            limit : 100,
            ShippingID:this.awbnumbers,
            isCsvDownload: false,
            ShipmentType : this.ShipmentType,
            AOR : this.AOR,
        };
        if (this.awbnumbers.length>0) {
         let shippingId=this.awbnumbers.split(/[\s,]+/);
         let shipmentReqArray = [];
         $.each(shippingId, (key,shipmentId)=>{
           if(shipmentId != ''){
             shipmentReqArray.push(shipmentId.trim())
           }
           if(shipmentReqArray.length > 100){
             this.$alertify.error("Maximum 100 shippingID you can enter.")
           }else{
             data.ShippingID = shipmentReqArray;
           }
         })
       }
        if (this.usernames){
          let userNameArr = []
          userNameArr.push(this.usernames)
          data.username = userNameArr
        }
        data.userid = this.localusermailid
        axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getShipmentList',data)
          .then((response) => {
            if(response.data.code == 200){
              this.searchflag=true;
              this.ShipmentData = response.data.data;
              this.ShipmentData.map(data => {
                data.shipmentlostdebitdetails.map(data2 => {
                  data.DebitDate = data2.CreatedDate//!= undefined ? data.ShipmentLostDebitDetails[0].CreatedDate : ""
                })
              })
              this.Loading = false;
               let totalRows = response.data.totalCount;
               this.totalRecords = totalRows
               if (totalRows < 100) {
                   this.pagecount = 1;
               } else {
                   this.pagecount = Math.ceil(totalRows / 100)
               }
            }else if(response.data.code == 204) {
              this.searchflag= false;
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error("No Pending Approval");
            }else if(response.data.code == 202) {
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }else{
              this.Loading = false;
              this.ShipmentData = [];
              this.$alertify.error(response.data.message);
            }
          })
        .catch((httpException) => {
            console.error('exception is:::::::::',httpException)
        });
      }
      else {
        this.$alertify.error("To Date is greter than from Date");
      }
  },
     debitNoteSubmit(){

       let getDetails = this.raiseRMDebitNoteData;
     },
     exportForm(){

     },
     getHubList(hubZoneID){
       let url = 'UpdateShipment/gethublist';
       if(hubZoneID != 'hubList') url = `external/getzonewisehublist?zoneid=${hubZoneID}`;

       axios.get(apiUrl.api_url + url)
         .then((response) => {
             if(response.data.code ==200){
                 this.hubList=response.data.data;
                 this.hubList.sort(function(a, b){
                  var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                  if (nameA < nameB) //sort string ascending
                   return -1
                  if (nameA > nameB)
                   return 1
                  return 0 //default return value (no sorting)
                 });
             }
             else {
                 this.hubList=[];
             }
         })
         .catch((httpException) => {
               this.$alertify.error("Hub List not found");
               console.error('exception is:::::::::', httpException)
         })
     },
     getHubZoneList(){
         axios.get(apiUrl.api_url + 'external/gethubzonelist')
         .then((response) => {
           this.hubZoneList = response.data.data;
         })
       .catch((httpException) => {
           console.error('exception is:::::::::',httpException)
       });
     },
  getCenterTypeList() {
    axios.post(apiUrl.api_url + 'external/getCentreTypeList')
      .then((response) => {
        if (response.data.code == 200) {
          console.log("response",response);
          this.CenterTypeList = response.data.data;
        }
        else {
          this.CenterTypeList = [];
          this.$alertify.error(response.data.message);

        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
  },

     getRaiseRMDebitNoteForEdit(ShipmentLostID){
       this.raiseRMDebitNoteEditflag= true;
       this.LoaderForPopup = true ;
       let data={
         ShipmentLostMasterID:ShipmentLostID
       }
       axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
         .then((response) => {
           let data1={
             userdetail:response.data.data
           }
           axios.post(apiUrl.api_url + 'external/getEmpName',data1)
             .then((response1) => {
               if(response1.data.code == 200){
                  this.LoaderForPopup = false ;
                  this.raiseRMDebitNoteData = response1.data.data;
                  let sumofAllDebitAmount=0;
                    let getResult = response1.data.data;

                    for(let i=0; i< getResult.length;i++){
                      if(getResult[i].DebitFromType == "ServiceCenter"){

                        this.selectEditItemsList.push(getResult[i].UserID);
                        this.debitPersonAmount[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitAmount);
                        this.debitPersonPercent[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].DebitPercentage);
                        this.getShipmentLostDetailsID[parseInt(getResult[i].UserID)] = parseFloat(getResult[i].ShipmentLostDetailsID);

                      }else if(getResult[i].DebitFromType == "Vendor" || getResult[i].DebitFromType == "NetworkVendor"){

                        this.selectEditItemsList.push(getResult[i].VehicleVendorID);
                        this.debitPersonAmount[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitAmount);
                        this.debitPersonPercent[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                        this.getShipmentLostDetailsID[parseInt(getResult[i].VehicleVendorID)] = parseFloat(getResult[i].ShipmentLostDetailsID);

                      }else if(getResult[i].DebitFromType == "Coloader"){

                        this.selectEditItemsList.push(getResult[i].ColoaderID);
                        this.debitPersonAmount[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitAmount);
                        this.debitPersonPercent[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                        this.getShipmentLostDetailsID[parseInt(getResult[i].ColoaderID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
                      }else if(getResult[i].DebitFromType == "Courier"){

                        this.selectEditItemsList.push(getResult[i].CourierID);
                        this.debitPersonAmount[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitAmount);
                        this.debitPersonPercent[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].DebitPercentage == null ? 100 : getResult[i].DebitPercentage);
                        this.getShipmentLostDetailsID[parseInt(getResult[i].CourierID)] = parseFloat(getResult[i].ShipmentLostDetailsID);
                      }
                      sumofAllDebitAmount = parseFloat(sumofAllDebitAmount)+ parseFloat(getResult[i].DebitAmount);

                    }

                  this.isDebitPersonSelected = this.selectEditItemsList.length;
                  this.amount = sumofAllDebitAmount;
                  this.getShipmentLostMasterID = ShipmentLostID;
               }else if (response1.data.code=204) {
                 this.LoaderForPopup = false ;
                 this.raiseRMDebitNoteData = [];
               }else if (response1.data.code=202) {
                 this.LoaderForPopup = false ;
                 this.raiseRMDebitNoteData = [];
               }else {
                 this.LoaderForPopup = false ;
                 this.raiseRMDebitNoteData = [];
               }
             });

         })
       .catch((httpException) => {
           console.error('exception is:::::::::',httpException)
       });

     },
     approveAllRecolrd(){
       if(this.selectedItems.length == 0){
         this.$alertify.error("please select atleast one Record");
       }else {
         let endResult=[];
         this.RmApproveLoaderBtn = true
         for (let i = 0; i < this.selectedItems.length; i++) {
           let result = this.ShipmentData.find( shipmentData => shipmentData.ShipmentLostMasterID == this.selectedItems[i] );
           endResult.push(result)
         }
         let payload=[];
         for (let j = 0; j < endResult.length; j++) {
           let debitPersonDetailsArray=[];
          for (let p = 0; p < endResult[j].shipmentlostdebitdetails.length; p++) {
            let debitPersonDetailsobj={
              ShipmentLostDetailsID:endResult[j].shipmentlostdebitdetails[p].ShipmentLostDetailsID,
              DebitAmount:endResult[j].shipmentlostdebitdetails[p].DebitAmount,
              DebitPercentage:endResult[j].shipmentlostdebitdetails[p].DebitPercentage
            }
            debitPersonDetailsArray.push(debitPersonDetailsobj);
          }
          this.newid.push(endResult[j].ShipmentLostMasterID)
           let data=  {
                        "ShipmentLostMasterID": endResult[j].ShipmentLostMasterID,
                        "DebitPersonDetails":debitPersonDetailsArray,
                        "Comments": "Success",
                        "LastModifiedBy":this.localusermailid
                    }
            payload.push(data);
         }
         axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/approveDebit',payload)
         .then((response) => {
           let masterID = String(this.newid)
           let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.localuserid,
            username:this.localusermailid,
            meta :
            {
              "event":"RMApproval",
              "ShipmentLostMasterID" : masterID
            }
          }
          this.PageTracker(TrackerInfo);
           this.modelValue = true
           this.approvalDebitResultStatus = response.data.data;
           this.approvalDebitResultStatus.forEach((obj) => {
             this.ShipmentData.find(shipmentData => {
               if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostDetailsID) {
                 obj.shippingIDs = shipmentData.ShippingID
               }
             })
           })
           let vm = this
           setTimeout(function(){
             vm.modelValue = false
             vm.searchData();
           }, 20000);
           if(response.data.code=200){
              // this.$alertify.success(response.data.message);
              this.selectedItems = [];
           } else if(response.data.code=202) {
             // this.$alertify.error(response.data.message);
           }else {
             // this.$alertify.error("Internal server Error");
           }
           this.RmApproveLoaderBtn = false
           this.totalSelectedRecords = 0
         })
       .catch((httpException) => {
         this.RmApproveLoaderBtn = false
         this.totalSelectedRecords = 0
           console.error('exception is:::::::::',httpException)
       });
       }
     },
     getShipmentsPopup(shipmentLostMasterID){
       this.attachmentLoader = true
       this.getDebitAmountDataLog = []
       let data={
         ShipmentLostMasterID:shipmentLostMasterID
       }
       axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
         .then((response) => {
             if(response.data.code=200){
                this.getDebitAmountDataLog = response.data.data;
             }else if (response.data.code=204) {
               this.getDebitAmountDataLog = [];
             }else if (response.data.code=202) {
               this.getDebitAmountDataLog = [];
             }else {
               this.getDebitAmountDataLog = [];
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
           this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
       this.getShipmentsflag= true;
       this.getShipmentslog();
     },

     getDebitAmountPopup(shipmentLostID){
       this.getDebitAmountflag= true;
       this.getDebitAmountData = []
       let data={
         ShipmentLostMasterID:shipmentLostID
       }
       this.attachmentLoader = true
       axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getDebitDetails',data)
         .then((response) => {
             if(response.data.code=200){
                this.getDebitAmountData = response.data.data;

             }else if (response.data.code=204) {
               this.getDebitAmountData = [];
             }else if (response.data.code=202) {
               this.getDebitAmountData = [];
             }else {
               this.getDebitAmountData = [];
             }
             this.attachmentLoader = false
           })
         .catch((httpException) => {
           this.attachmentLoader = false
             console.error('exception is:::::::::',httpException)
         });
     },
     getShipmentAttachmentPopup(shippingID){
       this.attachmentLoader = true
       this.getAttachmentFlag= true
       let data={
         ShippingID: shippingID
       }
       axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
         .then((response) => {
             if(response.data.code == 200){
                this.getAttachmentListData = response.data.data;
             } else {
               this.getAttachmentListData = [];
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
              this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
     },
     closeAttachmentPopup(){
      this.getAttachmentFlag = false
     },
     getShipmentslog(ShippingID){
       this.getShipmentsSummeryData=[];
       axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${ShippingID}`)
         .then((response) => {
             this.shipmentlogmodal = true;
             if(response.data.code===200){
                 this.getShipmentslogData = response.data.data;
                 this.getShipmentsflag = true;
                 this.getShippingIdforLog = ShippingID;
             }
             else {
                 this.shipmentLogList = [];
             }
         })
         .catch((httpException) => {
               this.$alertify.success("Shpment Log data not found");
               console.error('exception is:::::::::', httpException)
         })
     },
     getShipmentsSummery(){
       this.getShipmentslogData=[];
       this.getShipmentsSummeryData=[];
     },
     getImage(){
       // console.log("inside get image");
     },
     closeonPopup() {
       this.getShipmentslogData=[]
       this.getShipmentslogData=[];
       this.getDebitAmountData=[];
       this.raiseRMDebitNoteData=[];
       this.amount=0;
       this.raiseRMDebitNoteEditflag = false;
       this.getShipmentsflag= false;
       this.getDebitAmountflag= false;
       this.raiseRMDebitNotecomment='';
       this.DebitShareinRs=[];
       this.Percentage='';
       this.selectEditItemsList = [];
       this.$validator.reset();
       this.errors.clear();
     },
     calculateDebitAmout(DebitAmount,percentVal = 100,userid=''){
       if(this.selectEditItemsList.length > 0){
         this.isDebitPersonSelected = this.selectEditItemsList.length;
         if(userid != '' && document.getElementById(userid).checked == false){

           this.debitPersonPercent[userid] = "";
           this.debitPersonAmount[userid] = "";
         }
         let selectDebitUsercount = this.selectEditItemsList.length;

         let percentage = 0;
         let amount = 0 ;
         if(DebitAmount == '' || DebitAmount == 0 || DebitAmount == 'undefined'){
             percentage = 0;
             amount = 0;
         }else{
            percentage = (parseFloat(percentVal) / parseFloat(selectDebitUsercount)).toFixed(2);
            amount = (parseFloat(DebitAmount) / parseFloat(selectDebitUsercount)).toFixed(2);
         }

         let raiseDebitAmount = 0;

         for(let i = 0; i<selectDebitUsercount ; i++){
           raiseDebitAmount = parseFloat(raiseDebitAmount) + parseFloat(amount);
           this.debitPersonPercent[this.selectEditItemsList[i]] = percentage;
           this.debitPersonAmount[this.selectEditItemsList[i]] = amount;
         }
         this.adjustDebitAmount = (parseFloat(DebitAmount) - parseFloat(raiseDebitAmount)).toFixed(2);
       }else{
         this.isDebitPersonSelected ="";
         this.debitPersonPercent[userid] = "";
         this.debitPersonAmount[userid] = "";
       }

     },
     adjustDebitPercenatge(getUserId){
       let getdebitshareAmount = this.debitPersonAmount[getUserId];
       let getpercentage = this.debitPersonPercent[getUserId];
       let DebitAmount = this.amount;
       let percentage = 0;

       if(getdebitshareAmount != ''){
         if(parseFloat(getdebitshareAmount) > parseFloat(DebitAmount)){
             document.getElementById('debitshare'+getUserId).classList.add("validate-error");
             this.$alertify.error("Entered amount should not be greater than debit amount");
             document.getElementById('debitshare'+getUserId).focus();
             this.isAPICallFlag = false;
         }else{
           let selectedUser = this.selectEditItemsList.length;
             for(let i = 0; i<selectedUser ; i++){
               document.getElementById('debitshare'+this.selectEditItemsList[i]).classList.remove("validate-error");
               document.getElementById('percentage'+this.selectEditItemsList[i]).classList.remove("validate-error");
             }
           this.isAPICallFlag = true;
         }
         percentage = ((parseFloat(getdebitshareAmount) / parseFloat(DebitAmount)) * 100).toFixed(2);
         this.debitPersonPercent[getUserId] = percentage;
       } else{
         this.isAPICallFlag = false;
         this.debitPersonAmount[getUserId] = 0;
         this.debitPersonPercent[getUserId] = 0;
         let filteredAry = this.selectedItems.filter(function(e) { return e !== getUserId });
         this.selectedItems = filteredAry;
         getdebitshareAmount = 0;
         //this.$alertify.error("false");
       }
       let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
       let totaleDebitPercent = (parseFloat(100) - parseFloat(percentage)).toFixed(2);

       let filteredAry = this.selectEditItemsList.filter(function(e) {
         return e != getUserId
      });

       let getNewUpdatepercent = this.debitPersonPercent[getUserId];
       this.selectEditItemsList = filteredAry;
       this.calculateDebitAmout(totaleDebitAmount,totaleDebitPercent);
       if(getdebitshareAmount != 0){
         var isExistuserid = this.selectEditItemsList.includes(Number(getUserId));
         if(!isExistuserid){
           this.selectEditItemsList.splice(0, '', Number(getUserId));
         }
       }

       if(this.selectEditItemsList.length>0){
         this.isDebitPersonSelected = this.selectedItems.length;
       }else{
         this.isDebitPersonSelected = "";
       }
     },
     adjustDebitAmout(getUserId){
       let getpercentage = this.debitPersonPercent[getUserId];
       let DebitAmount = this.amount;

       if(getpercentage !=''){
         if(getpercentage > 100){
             document.getElementById('percentage'+getUserId).classList.add("validate-error");
             this.$alertify.error("Entered percent should not be greater than 100%");
             document.getElementById('percentage'+getUserId).focus();
             this.isAPICallFlag = false;
         }else{
           let selectedUser = this.selectEditItemsList.length;
           for(let i = 0; i<selectedUser; i++){
             document.getElementById('debitshare'+this.selectEditItemsList[i]).classList.remove("validate-error");
             document.getElementById('percentage'+this.selectEditItemsList[i]).classList.remove("validate-error");
           }
           this.isAPICallFlag = true;
         }
         let TotAmount = ((parseFloat(DebitAmount) / parseFloat(100)) * parseFloat(getpercentage) ).toFixed(2);
         this.debitPersonAmount[getUserId] = TotAmount;
       }else{
         this.isAPICallFlag = false;
         this.debitPersonAmount[getUserId] = 0;
         this.debitPersonPercent[getUserId] = 0;
         let filteredAry = this.selectedItems.filter(function(e) { return e !== getUserId });
         this.selectedItems = filteredAry;
         getpercentage = 0;
         //this.$alertify.error("false");
       }

       let getdebitshareAmount = this.debitPersonAmount[getUserId];
       let totaleDebitAmount = parseFloat(DebitAmount) - parseFloat(getdebitshareAmount);
       let totaleDebitPercent = (parseFloat(100) - parseFloat(getpercentage)).toFixed(2);
       let filteredAry = this.selectEditItemsList.filter(function(e) { return e != getUserId });

       this.selectEditItemsList = filteredAry;
       this.calculateDebitAmout(totaleDebitAmount,totaleDebitPercent);
       if(getpercentage !=''){
         var isExistuserid = this.selectEditItemsList.includes(Number(getUserId));
         if(!isExistuserid){
           this.selectEditItemsList.splice(0, " ", Number(getUserId));
         }
       }
       if(this.selectEditItemsList.length>0){
         this.isDebitPersonSelected = this.selectedItems.length;
       }else{
         this.isDebitPersonSelected = "";
       }
     },
     calculateTotalEnteredAmt(){
         let len = this.selectEditItemsList.length;
         let debitTotal = 0;
         for(let i = 0; i<len ; i++){
           let debitshare = this.debitPersonAmount[this.selectEditItemsList[i]];
           debitTotal = parseFloat(debitTotal) + parseFloat(debitshare);
         }
         //debitTotal = parseFloat(debitTotal) + parseFloat(this.adjustDebitAmount);
         if(parseFloat(debitTotal).toFixed(1) === parseFloat(this.amount).toFixed(1)){
           this.isAPICallFlag = true;
         } else {
           this.$alertify.error("Debit amount not matched");
           this.isAPICallFlag = false;
         }
     },
     getPaginationData(pageNum) {
       this.pageno = pageNum;
       this.selectedItems = []
       this.totalSelectedRecords = 0
       this.selectAllItems = false
       this.SearchShipmets();
     },
///THIS CSV DOWNLOAD START
downloadCsv() {
  if(this.toDate >= this.fromDate ){

    this.ExportRmApproveLoaderBtn = true;
    let hubIDarray = []
    if(this.hubID.length > 0 ){
      this.hubID.map(hub=>{
        hubIDarray.push(hub.HubID)
      })
    }
    if (this.ShipmentType =="All"){
      this.ShipmentType = ""
    }
    let data={
        fromDate:this.fromDate ,
        toDate: this.toDate,
        HubZoneID: this.hubzoneid,
        DebitFromType: this.debitFrom,
        HubId: hubIDarray,
        Vertical: this.Vertical,
        CenterType: this.CenterType,
        offset : this.pageno - 1,
        limit : 100,
        ShippingID:this.awbnumbers,
        isCsvDownload: false,
        ShipmentType : this.ShipmentType
    };
    if (this.awbnumbers.length>0) {
      let shippingId=this.awbnumbers.split(/[\s,]+/);
      let shipmentReqArray = [];
      $.each(shippingId, (key,shipmentId)=>{
        if(shipmentId != ''){
          shipmentReqArray.push(shipmentId.trim())
        }
        if(shipmentReqArray.length > 100){
          this.$alertify.error("Maximum 100 shippingID you can enter.")
        }else{
          data.ShippingID = shipmentReqArray;
        }
      })
    }
    axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/getShipmentList',data)
      .then((response) => {
        if(response.data.code == 200){
          let data1={
            "hubDetailes":response.data.data
          }
           axios.post(apiUrl.api_url + 'external/EmpDetails/List',data1)
             .then((response1) => {
               //this.ShipmentData = response1.data.data;
               let csvArrayExportObj = [];

               response1.data.data.forEach(function(item){

                 let debitNames = item['shipmentlostdebitdetails'].map(function(childItem) {
                    return childItem['DebitFrom'];
                  });
                 csvArrayExportObj.push({
                   "Shipping ID": item.ShippingID,
                   "Client Name": item.ClientName,
                   "Zone": item.HubZoneName,
                   "Hub Name" : item.HubName,
                   "Status":item.Status,
                   "Debit From" : item.DebitFromType,
                   "Debit Amount" : item.DebitAmount,
                   "Debit Concern Person" : debitNames.join('  -  '),
                   "Docket No" : item.DocketNumber,
                   "Debit Date" : item.CreatedDate,
                   "Lastmodified Date" : item.LastModifiedDate,
                   "Created By" : item.CreatedBy,
                   "Comments" : item.Comments,

                   }
                 )
               });
               this.ExportRmApproveLoaderBtn = false;
               this.exportCsv(csvArrayExportObj);
             })
           .catch((httpException) => {
               console.error('exception is:::::::::',httpException)
           });
        }else if(response.data.code == 204) {
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error("No Pending Approval");
        }else if(ExportRmApproveLoaderBtn.data.code == 202) {
          this.Loading = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }else{
          this.ExportRmApproveLoaderBtn = false;
          this.ShipmentData = [];
          this.$alertify.error(response.data.message);
        }
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  }
  else {
    this.$alertify.error("To Date is greter than from Date");
  }
},
exportCsv(shipmentObjectdata) {
  let csvContent = "data:text/csv;charset=utf-8,";
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  var today = dd + "" + mm + "" + yyyy;
  let filename = "RMApproveDebit" + today + ".csv";
  csvContent += [
    Object.keys(shipmentObjectdata[0]).join(";"),
    ...shipmentObjectdata.map(item => Object.values(item).join(";"))
  ]
  .join("\n")
  .replace(/(^\[)|(\]$)/gm, "");

  const data = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
},
selectItems(ev) {
    this.selectedItems = [];
    if (ev.target.checked == true) {
        for (let i in this.ShipmentData) {
          this.selectedItems.push(this.ShipmentData[i].ShipmentLostMasterID.toString());
        }
    }
    this.totalSelectedRecords = this.selectedItems.length
    //this.calculateDebitAmout(this.amount,100);
  },
  selectItemsonPopup(ev) {
      this.selectEditItemsList = [];
      if (ev.target.checked == true) {
          for (let i in this.raiseRMDebitNoteData) {

            if(this.raiseRMDebitNoteData[i].DebitFromType === "Vendor" || this.raiseRMDebitNoteData[i].DebitFromType === "NetworkVendor"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].VehicleVendorID);

            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "ServiceCenter"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].UserID);
            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "Coloader"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].ColoaderID);
            } else if(this.raiseRMDebitNoteData[i].DebitFromType === "Courier"){
              this.selectEditItemsList.push(this.raiseRMDebitNoteData[i].CourierID);
            }
          }
      }else{
        for (let i in this.raiseRMDebitNoteData) {
          if(this.raiseRMDebitNoteData[i].DebitFromType === "Vendor" || this.raiseRMDebitNoteData[i].DebitFromType === "NetworkVendor"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].VehicleVendorID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].VehicleVendorID] = "";

          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "ServiceCenter"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].UserID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].UserID] = "";

          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "Coloader"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].ColoaderID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].ColoaderID] = "";
          }else if(this.raiseRMDebitNoteData[i].DebitFromType === "Courier"){
            this.debitPersonPercent[this.raiseRMDebitNoteData[i].CourierID] = "";
            this.debitPersonAmount[this.raiseRMDebitNoteData[i].CourierID] = "";
          }

        }
        this.selectEditItemsList = [];
      }
      this.calculateDebitAmout(this.amount,100);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          this.calculateTotalEnteredAmt();
          if(this.isAPICallFlag == true){
             //this.raiseRMDebitNoteEditflag = false;
             let debitConcernsDetails = [];
             let usercount = this.selectEditItemsList.length;
             for (let i = 0; i< usercount; i++) {

               let debitShareAmount = this.debitPersonAmount[this.selectEditItemsList[i]];
               let debitpercentage = this.debitPersonPercent[this.selectEditItemsList[i]];
               let getShipmentLostDetailsId =  this.getShipmentLostDetailsID[this.selectEditItemsList[i]];

               debitConcernsDetails.push({
                 "ShipmentLostDetailsID" : getShipmentLostDetailsId,
                 "DebitAmount": debitShareAmount,
                 "DebitPercentage": debitpercentage
               });
             }
             let RaiseDebitPayload = [{
               "ShipmentLostMasterID" :this.getShipmentLostMasterID,
               "DebitPersonDetails" : debitConcernsDetails,
               "Comments":this.raiseRMDebitNotecomment,
               "LastModifiedBy" : this.localusermailid
             }]
             axios.post(apiUrl.api_url + 'shipmentLost/RMApproval/approveDebit', RaiseDebitPayload)
              .then((response) => {
                  this.modelValue = true
                  this.approvalDebitResultStatus = response.data.data;
                  this.approvalDebitResultStatus.forEach((obj) => {
                    this.ShipmentData.find(shipmentData => {
                      if( shipmentData.ShipmentLostMasterID == obj.ShipmentLostDetailsID) {
                        obj.shippingIDs = shipmentData.ShippingID
                      }
                    })
                  })
                  let vm = this
                  setTimeout(function(){
                    vm.modelValue = false
                    vm.searchData();
                  }, 20000);
                   if(response.data.code === 200){
                       // this.$alertify.success("Approve debit successful");
                       this.searchData();
                       this.raiseRMDebitNoteEditflag= false;
                       this.totalSelectedRecords = 0
                   }
                   else if(response.data.code === 202){
                       // this.$alertify.error("Already Approved debit");
                       this.raiseRMDebitNoteEditflag= false;
                       this.totalSelectedRecords = 0
                   }else{
                     this.$alertify.error(response.data.message);
                   }
               })
               .catch((httpException) => {
                     this.$alertify.success("Failed to approve debit");
                     console.error('exception is:::::::::', httpException)
               })
             this.selectEditItemsList = [];
             this.raiseRMDebitNoteEditflag = false;
          }
       }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });

    },
    clear(){
      this.getServiceCentreList("");
      this.ShipmentType = '';
      this.awbnumbers = '';
      this.Vertical = '';
      this.CenterType = ''
      this.totalSelectedRecords = 0
      this.getHubList("hubList");
      this.raiseRMDebitNoteData=[];
      this.RMApproveAllRecord = '';
      this.fromDate = '';
      this.toDate = '';
      this.hubname='';
      this.hubzoneid='';
      this.debitFrom='';
      this.searchflag=false;
      this.ShippingId='';
      this.raiseRMDebitNotecomment='';
      this.DebitShareinRs='';
      this.Percentage='';
      this.hubID='';
      this.CenterType = '';
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.pagecount = 0;
      this.selectedItems = [];
      this.errors.clear();
      this.hubList = [];
      this.hubStateId = ''
      this.hubCitybyStateList = [],
      this.hubCityId = ''
      this.AOR = '';
      this.selectedHubZoneId = '';
      this.selectedStateId = '';
      this.selectedCityId = '';
      this.selectedAOR = '',
      this.selectedCenterType = '',
      this.filteredHubList = [],
      this.filterHubList(),
      // this.modelValue = false
      this.usernames = ''
    },
    closeApprovalResultModel() {
      this.modelValue =false
    },
    onApproveClear() {
      this.selectedItems = [];
      this.totalSelectedRecords = 0
    },
    getServiceCentreList(selectedCentreType) {
      this.selectedCenterType = selectedCentreType
      this.filterHubList()
    },
    getHubStateList(){
      axios.get(apiUrl.api_url + 'external/stateList')
      .then((response) => {
        this.hubStateList = response.data.data;
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
    },

    getCitiesbyState(event){
      this.selectedStateId = event.target.value
      this.filterHubList()
    let data={
      stateID:[event.target.value]
    }
    axios.post(apiUrl.api_url + 'external/citiesByState',data)
      .then((response) => {
        this.hubCitybyStateList = response.data.data;
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  },

  getAORList(){
    axios.get(apiUrl.api_url + 'external/AORList')
      .then((response) => {
        this.AORList = response.data.data;
      })
    .catch((httpException) => {
        console.error('exception is:::::::::',httpException)
    });
  },

  getHubsByCities(event){
    this.selectedCityId = event.target.value
    this.filterHubList()
  },

  getHubsByAOR(AOR){
    this.selectedAOR = AOR
    this.filterHubList()
  },

  getHubsByZoneId(event){
    this.selectedHubZoneId = event.target.value
    this.filterHubList()
  },

  filterHubList() {
    let data = {}
    if (this.selectedHubZoneId != '') {
      data.zoneId = this.selectedHubZoneId
    }
    if (this.selectedStateId != '') {
      data.stateId = this.selectedStateId
    }
    if (this.selectedCityId != '') {
      data.cityId = this.selectedCityId
    }
    if (this.selectedCenterType != '') {
      data.centerType = [this.selectedCenterType]
    } else {
      data.centerType = []
    }
    if (this.selectedAOR != '') {
      data.AOR = this.selectedAOR
    }
    axios.post(apiUrl.api_url + 'external/filterHubDetails', data)
      .then((response) => {
        this.filteredHubList = response.data.data;
        console.log("this.filteredHubList",this.filteredHubList)
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      });
  },
  showDebitFromModal(shippingId){
    this.debitFromModal = true
    let debitDetails = this.ShipmentData.filter(x => x.ShippingID == shippingId)
    this.debitPersonDetails = debitDetails[0].shipmentlostdebitdetails
  },
  closeDebitFromModal(){
    this.debitFromModal = false
  }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    moment2: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
}
$('.pane-hScroll').scroll(function() {
  $('.pane-vScroll').width($('.pane-hScroll').width() + $('.pane-hScroll').scrollLeft());
});



// WEBPACK FOOTER //
// ./src/views/components/LOST/RMApprove/RMApprove.component.js